import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../../components/Layout"
import * as styles from "../../styles/industry.module.css"

const imageFor = (images, relativePath) =>
  images.nodes.find(image => image.relativePath === relativePath)

const SupconIndustry = ({ data }) => {
  const inner = imageFor(data.images, "supconIntro/inner1.jpg")

  return (
    <Layout>
      <article className={styles.detail}>
        <Link className={styles.backLink} to="/industry">
          industry/
        </Link>

        <header className={styles.detailHeader}>
          <p>SUPCON Technology</p>
          <h1>DCS Laboratory Development and Industrial Training</h1>
          <span>May 2026 - Present</span>
        </header>

        {inner && (
          <Img
            className={styles.heroImage}
            fluid={inner.childImageSharp.fluid}
            alt="SUPCON laboratory control system interface"
          />
        )}

        <section className={styles.detailGrid}>
          <div className={styles.detailText}>
            <p>
              In May 2026, I completed a hands-on training program delivered by
              SUPCON Canada engineers during the commissioning of an ECS-700
              distributed control system and a coupled-tank level-control unit
              in our laboratory.
            </p>

            <p>
              The training introduced the complete workflow of an industrial
              DCS, from field measurements and controller hardware to control
              logic and operator interfaces. Through demonstrations and
              practical exercises, I gained experience in:
            </p>

            <ul>
              <li>
                Understanding the basic architecture of a DCS, including
                controllers, I/O modules, engineering stations, and operator
                stations
              </li>
              <li>
                Configuring basic I/O tags, signal ranges, engineering units,
                and alarms
              </li>
              <li>
                Building simple control logic and a PID control loop using
                function blocks
              </li>
              <li>
                Creating HMI graphics for process monitoring, trends, alarms,
                and operator interaction
              </li>
            </ul>

            <p>
              Following the training, I have been collaborating with the
              laboratory team to develop course experiments using the ECS-700
              platform. These experiments are intended to help students connect
              process-control theory with practical DCS configuration,
              closed-loop control, and industrial automation.
            </p>

            <p>
              This experience gave me a practical understanding of how a control
              algorithm becomes part of a complete industrial system involving
              instrumentation, control hardware, engineering software, and
              operator supervision.
            </p>
          </div>

        </section>
      </article>
    </Layout>
  )
}

export default SupconIndustry

export const query = graphql`
  query SupconIndustryPage {
    images: allFile(
      filter: {
        sourceInstanceName: { eq: "industry" }
        extension: { in: ["jpg", "jpeg", "png", "webp"] }
      }
    ) {
      nodes {
        relativePath
        childImageSharp {
          fluid(maxWidth: 920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`
